// Note: do not use HOTELS_LOCAL_STORAGE_CACHE_KEY directly
// use getHotelsCacheKey(locale, taxonomy) util instead
export const HOTELS_LOCAL_STORAGE_CACHE_KEY = 'axp-travel-search-hotels/hotel';
export const COMMON_LOCAL_STORAGE_CACHE_KEY = 'axp-consumer-travel/searchParameters';
